import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-trim-string-tooltip',
  templateUrl: './trim-string-tooltip.component.html',
  styleUrls: ['./trim-string-tooltip.component.scss']
})
export class TrimStringTooltipComponent implements OnInit , ICellRendererAngularComp {
  cellValue: any;
  constructor() { }

  ngOnInit(): void {
  }

  agInit(params: any): void {
    this.cellValue = params.value;
    this.cellValue = JSON.stringify(params.value);
  }
  refresh(params: any): boolean {
    this.cellValue = params.value;
    this.cellValue = JSON.stringify(params.value);
    return true;
  }
}